/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Who2_LinkInputs */

const en_dr_who2_link = /** @type {(inputs: Dr_Who2_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See Bystep Studio`)
};

const id_dr_who2_link = /** @type {(inputs: Dr_Who2_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Bystep Studio`)
};

/**
* | output |
* | --- |
* | "See Bystep Studio" |
*
* @param {Dr_Who2_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_who2_link = /** @type {((inputs?: Dr_Who2_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Who2_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_who2_link(inputs)
	return en_dr_who2_link(inputs)
});